import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TopPageTitle from "../../../components/TopPageTitle/TopPageTitle";
import Modal from "../../../components/Modal/Modal";
import { PagesWrapper } from "../../../styles/components/PagesWrapper.styled";
import useAuthData from "../../../hooks/useAuthData";
import Loader from "../../../components/Loader/Loader";
import axios from "../../../axios";
import RescheduleTeacherBlock from "../../../components/RescheduleTeacherBlock/RescheduleTeacherBlock";
import { fetchAuthMe } from "../../../redux/slices/auth";
import { getWeekStartDate } from "../../../helpers/weekUtils";
const days = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

function Schedule() {
  const dispatch = useDispatch();
  // const data = useAuthData(dispatch);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [reschedules, setReschedules] = useState([]);
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [rescheduleSubmited, setRescheduleSubmited] = useState(false);
  const [loading, setLoading] = useState(false)
  const [slotSubmited, setSlotSubmited] = useState(false)
  const [data, setData] = useState(null);
  const [currentWeek, setCurrentWeek] = useState(getWeekStartDate());
  useEffect(() => {
    if (!data) return;
    const weekStart = new Date(currentWeek);
    weekStart.setUTCHours(0, 0, 0, 0);
    axios.get(`lesson-reschedule/${data._id}?weekStartDate=${weekStart.toISOString()}`)
      .then((res) => {
        
        setReschedules(res.data.lesson);
        if (rescheduleSubmited) setRescheduleSubmited(false);
      })
      .catch((err) => console.error(err));
  }, [data, rescheduleSubmited, currentWeek]);

  
  useEffect(() => {
    const fetchData = async () => {
          const response = await dispatch(fetchAuthMe());
          setData(response.payload);
          setSlotSubmited(false)
    };

    fetchData();
  }, [dispatch, slotSubmited]);
  const joinedLesson = () => {
    axios.post("teacher/joined-lesson", {
      lessonData: {
        teacherName: data.name,
        studentName: selectedLesson.name,
        studentId: selectedLesson.studentId,
        lessonTime: selectedLesson.time,
        accessType: data.accessType
      },
    });
  };
  


  if (!data || !data.students || !data.trialLessons || !reschedules) {
    return <Loader />;
  }

  const handleCloseModal = () => {
    setSelectedLesson(null);
    setRescheduleModal(false);
  };



  return (
    <PagesWrapper>
      <TopPageTitle value={"Графік"} />
      <RescheduleTeacherBlock
        teacher={data}
        reschedules={reschedules}
        handleCloseModal={handleCloseModal}
        joinedLesson={joinedLesson}
        setRescheduleSubmited={setRescheduleSubmited}
        selectedLesson={selectedLesson}
        setSelectedLesson={setSelectedLesson}
        rescheduleModal={rescheduleModal}
        setRescheduleModal={setRescheduleModal}
        setSlotSubmited={setSlotSubmited}
        currentWeek={currentWeek} 
        setCurrentWeek={setCurrentWeek}
        setReschedules={setReschedules}
      />
    </PagesWrapper>
  );
}

export default Schedule;